module.exports = __webpack_public_path__ + "img/settings.6179f7e5.svg";